"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = void 0;

var _styledComponents = require("styled-components");

var _polished = require("polished");

/**
 * @param  {} breakpoint
 * Example:
 * ${media(720px)`padding: 0 20px;`}
 */
const media = breakpoint => (...args) => (0, _styledComponents.css)(["@media (max-width:", "){", ";}"], (0, _polished.rem)(breakpoint), (0, _styledComponents.css)(...args));

exports.media = media;